<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense class="slide-card-up" justify="center">
            <h1 v-if="camino != null" class="mt-0 ma-4 mr-12">{{ $t('mensajes.inicial') }} {{ esAgencia ?
                this.agencia.nombre : '' }}</h1>
        </v-row>
        <v-row v-if="camino != null" dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    {{ $t('mensajes.descripcion') }}
                </p>
            </v-col>
        </v-row>

        <v-container>

            <v-row justify="center" v-if="pasajerosGuardados">
                <v-col justify="center">
                    <h2 class="text-center">
                        {{ $t('mensajes.datos_pasajeros.mensaje_final_success') }}
                    </h2>
                </v-col>
            </v-row>

            <v-row justify="center" v-if="!pasajerosGuardados">
                <v-col align="center">
                    <v-row class="mt-0 mb-2">
                        <v-col justify="start">
                            <p class="mx-0" style="text-align: start;">
                                {{ $t('mensajes.datos_pasajeros.titulo') }}
                            </p>
                        </v-col>
                    </v-row>

                    <!-- Formulario de Pasajeros -->
                    <v-row>
                        <v-col v-for="({ pasajero, index }) in pasajerosMostrados" :key="index" cols="12" md="6" class="d-flex">
                            <v-card class="mx-2 pa-4 card-personalizada slide-card flex-grow-1"
                                style="min-width: 5cqb;">
                                <v-card-title>
                                    {{ $t('mensajes.datos_pasajeros.datos_peregrino', { index: index + 1 }) }}
                                </v-card-title>
                                <v-card-text>
                                    <div>


                                        <v-row dense class="mt-6 mb-2">
                                            <v-text-field v-model="pasajero.nombre" class="mb-2"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'nombre') }"
                                                :label="$t('mensajes.datos_pasajeros.nombre')" type="text" outlined
                                                dense autocomplete="off" hide-details>
                                            </v-text-field>
                                        </v-row>

                                        <v-row dense class="mb-2">
                                            <v-col cols="6">
                                                <v-text-field v-model="pasajero.primer_apellido" class="mb-2"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'primer_apellido') }"
                                                    :label="$t('mensajes.datos_pasajeros.primer_apellido')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field v-model="pasajero.segundo_apellido" class="mb-2"
                                                    :label="$t('mensajes.datos_pasajeros.segundo_apellido')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                                            <v-col cols="6">
                                                <v-select v-model="pasajero.sexo" :items="sexos" item-text="name"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'sexo') }"
                                                    :label="$t('mensajes.datos_pasajeros.sexo')"
                                                    item-value="value" outlined dense hide-details class="mb-2">
                                                </v-select>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field v-model="pasajero.fecha_nacimiento" class="mb-2"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'fecha_nacimiento') }"
                                                    :label="$t('mensajes.datos_pasajeros.fecha_nacimiento')" outlined
                                                    dense hide-details placeholder="dd/mm/yyyy"
                                                    :rules="[validarFormatoFecha]" @input="formatearFecha"
                                                    maxlength="10">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row dense class="mb-2">
                                            <v-col v-if="!mostrarFormularioReducido" cols="4" class="pr-0">
                                                <v-select v-model="pasajero.tipo_documento" :items="tipoDeDocumentos"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'tipo_documento') }"
                                                    :label="$t('mensajes.datos_pasajeros.tipo_documento')"
                                                    item-text="name" item-value="value" outlined dense hide-details
                                                    class="mr-1">
                                                </v-select>
                                            </v-col>
                                            <v-col :cols="mostrarFormularioReducido ? 12 : (isSpanish && isNacionalidadEspania(pasajero) ? 5 : 8)" :class="mostrarFormularioReducido ? '' : 'pl-0'">
                                                <v-text-field v-model="pasajero.numero_documento"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'numero_documento') }"
                                                    :label="$t('mensajes.datos_pasajeros.numero_documento')"
                                                    :error="!isValidDocument(pasajero.tipo_documento, pasajero.numero_documento)"
                                                    type="text" outlined dense autocomplete="off" hide-details
                                                    @input="pasajero.numero_documento = $event.toUpperCase()">
                                                </v-text-field>
                                            </v-col>
                                            <v-col v-if="!mostrarFormularioReducido && isSpanish && isNacionalidadEspania(pasajero)" cols="3" class="pl-0">
                                                <v-text-field v-model="pasajero.soporte_documento"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'soporte_documento') }"
                                                    :label="$t('mensajes.datos_pasajeros.soporte_documento')"
                                                    type="text" outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row dense class="mb-2">
                                            <v-col v-if="!mostrarFormularioReducido" cols="6">
                                                <v-text-field v-model="pasajero.telefono_fijo"
                                                    :label="$t('mensajes.datos_pasajeros.telefono_fijo')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                            <v-col :cols="mostrarFormularioReducido ? 12 : 6">
                                                <v-text-field v-model="pasajero.telefono_movil"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'telefono_movil') }"
                                                    :label="$t('mensajes.datos_pasajeros.telefono_movil')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                                            <v-text-field v-model="pasajero.email"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'email') }"
                                                :label="$t('mensajes.datos_pasajeros.email')" type="text" outlined dense
                                                :error="pasajero.email && !_emailValido(pasajero.email)"
                                                autocomplete="off" hide-details>
                                            </v-text-field>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                                            <v-text-field v-model="pasajero.direccion"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'direccion') }"
                                                :label="$t('mensajes.datos_pasajeros.direccion')" type="text" outlined
                                                dense autocomplete="off" hide-details>
                                            </v-text-field>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                                            <v-col cols="6">
                                                <v-text-field v-model="pasajero.poblacion"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'poblacion') }"
                                                    :label="$t('mensajes.datos_pasajeros.poblacion')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-select v-if="isNacionalidadEspania(pasajero)"
                                                    v-model="pasajero.provincia" :items="provinciasEspana"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'provincia') }"
                                                    :label="$t('mensajes.datos_pasajeros.provincia')" outlined dense
                                                    hide-details>
                                                </v-select>
                                                <v-text-field v-else v-model="pasajero.provincia"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'provincia') }"
                                                    :label="$t('mensajes.datos_pasajeros.provincia')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                                            <v-col cols="6">
                                                <v-text-field v-model="pasajero.codigo_postal"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'codigo_postal') }"
                                                    :label="$t('mensajes.datos_pasajeros.codigo_postal')" type="text"
                                                    outlined dense autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-select v-model="pasajero.nacionalidad" :items="codigosPais"
                                                    item-text="name" item-value="name"
                                                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'nacionalidad') }"
                                                    :label="$t('mensajes.datos_pasajeros.nacionalidad')" outlined dense
                                                    hide-details>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="!mostrarFormularioReducido && isSpanish && isNacionalidadEspania(pasajero)" dense class="mb-2">
                                            <v-text-field v-model="pasajero.parentesco"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'parentesco') }"
                                                :label="$t('mensajes.datos_pasajeros.parentesco')" type="text" outlined
                                                dense autocomplete="off" hide-details>
                                            </v-text-field>
                                        </v-row>


                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row justify="end" class="mt-4">
                        <v-chip link large @click="formulariosValidados() ? _guardarDatosPasajeros() : null"
                            class="ma-2 px-8 mr-8" :class="{ 'hover-color': formulariosValidados() }"
                            :color="formulariosValidados() ? miColorAzul : 'grey'"
                            :text-color="formulariosValidados() ? miColorNaranja : 'white'" style="font-size: 1.2rem;">
                            {{ $t('mensajes.datos_pasajeros.guardar_datos') }}
                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                        </v-chip>
                    </v-row>

                    <v-row justify="start" class="mx-4 mt-12 mb-12">
                        <p class="mx-0" style="font-size: 0.8rem; text-align: start;">
                            {{ $t('mensajes.datos_pasajeros.politica_privacidad') }}
                        </p>

                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            language: 'es',
            step: 1,
            admin: false,
            serviciosNoIncluidos: [],

            pasajerosGuardados: false,

            loadingEnviandoPresupuesto: false,

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',

            modelReserva: {
                id: null,
                codigo: null,
                camino: null,
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                cant_habitaciones_individuales: 0,
                cant_habitaciones_dobles: 0,
                cant_habitaciones_dobles_matrimoniales: 0,
                cant_habitaciones_triples: 0,

                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                },
                pasajeros: [],
                cliente_es_viajero: true,
                origen_id: null
            },

            pasajeros: [],

            requiredPassengerFields: [
                'nombre',
                'primer_apellido',
                'sexo',
                'fecha_nacimiento',
                'tipo_documento',
                'numero_documento',
                'telefono_movil',
                'email',
                'direccion',
                'poblacion',
                'provincia',
                'codigo_postal',
                'nacionalidad'
            ],

        };
    },
    computed: {
        ...mapState("caminos", ["camino", "agencia"]),
        ...mapGetters('paises', ['getCodigosPais', 'getProvinciasEspana']),

        isSpanish() {
            return (this.language || '').toLowerCase() === 'es';
        },

        codigosPais() {
            return this.getCodigosPais;
        },

        provinciasEspana() {
            return this.getProvinciasEspana;
        },

        tipoDeDocumentos() {
            return [
                { name: this.$t('mensajes.datos_pasajeros.tipo_documento_opciones.dni'), value: 'DNI' },
                { name: this.$t('mensajes.datos_pasajeros.tipo_documento_opciones.nie'), value: 'NIE' },
                { name: this.$t('mensajes.datos_pasajeros.tipo_documento_opciones.pasaporte'), value: 'PASAPORTE' },
            ];
        },

        sexos() {
            return [
                { name: this.$t('mensajes.datos_pasajeros.sexo_opciones.hombre'), value: 'H' },
                { name: this.$t('mensajes.datos_pasajeros.sexo_opciones.mujer'), value: 'M' },
            ];
        },

        datosPasajerosCompletados() {
            return this.step === 5 && this.pasajeros.every(pasajero => pasajero.nombre && pasajero.primer_apellido && pasajero.documento && pasajero.tipo_documento);
        },
        mostrarFormularioReducido() {
            return Number(this.modelReserva.origen_id) > 1;
        },

        clienteEsViajero() {
            return this.modelReserva.cliente_es_viajero !== false;
        },

        pasajerosMostrados() {
            return this.pasajeros
                .map((pasajero, index) => ({ pasajero, index }))
                .filter(({ index }) => this.clienteEsViajero || index > 0);
        },

    },

    created() {
        this.pasajerosGuardados = false;
    },

    mounted() {
        this.language = this.$route.params.language.toLowerCase();
        this.$i18n.locale = this.language.toLowerCase();
        const hash = this.$route.params.hash;
        if (hash) {
            this._getReservaByHash(hash);
        }
    },

    methods: {
        ...mapActions("caminos", ["getCamino", "getAgencia", "createReserva", "guardarDatosPasajeros", "getReservaByHash"]),


        async _getReservaByHash(hash) {
            const reserva = await this.getReservaByHash([hash]);
            this.modelReserva.id = reserva.id;
            this.modelReserva.codigo = reserva.codigo;
            this.modelReserva.fecha_inicio = reserva.fecha_inicio;
            this.modelReserva.fecha_llegada = reserva.fecha_llegada;
            this.modelReserva.cant_peregrinos = reserva.cant_peregrinos;
            this.modelReserva.cant_habitaciones_individuales = reserva.cant_habitaciones_individuales;
            this.modelReserva.cant_habitaciones_dobles = reserva.cant_habitaciones_dobles;
            this.modelReserva.cant_habitaciones_dobles_matrimoniales = reserva.cant_habitaciones_dobles_matrimoniales;
            this.modelReserva.cant_habitaciones_triples = reserva.cant_habitaciones_triples;
            this.modelReserva.camino = reserva.camino;
            this.modelReserva.cliente.nombre = reserva.cliente.nombre;
            this.modelReserva.cliente.apellidos = reserva.cliente.apellidos;
            this.modelReserva.cliente.telefono = reserva.cliente.telefono;
            this.modelReserva.cliente.email = reserva.cliente.email;
            this.modelReserva.origen_id = reserva.origen.id;
            this.modelReserva.cliente_es_viajero = reserva.cliente_es_viajero !== false;

            this.modelReserva.pasajeros = reserva.pasajeros;
            this._pedirDatosPasajeros();
            console.log('Reserva cargada:', reserva);
        },

        isValidDocument(tipo, documento) {
            return !!(documento && documento.trim() !== '');
        },

        _pedirDatosPasajeros() {
            this.pasajeros = [];
            const tipoDocumentoPorDefecto = this.isSpanish ? 'DNI' : 'PASAPORTE';
            const totalPasajeros = this.modelReserva.cant_peregrinos + (this.clienteEsViajero ? 0 : 1);
            this.pasajeros = Array.from({ length: totalPasajeros }, (_, index) => {
                const pasajeroExistente = this.modelReserva.pasajeros && this.modelReserva.pasajeros[index];
                return {
                    codigo_postal: pasajeroExistente?.codigo_postal || null,
                    direccion: pasajeroExistente?.direccion || null,
                    documento: pasajeroExistente?.documento || null,
                    email: pasajeroExistente?.email || null,
                    fecha_nacimiento: this._formatFechaNacimientoFromApi(pasajeroExistente?.fecha_nacimiento),
                    id: pasajeroExistente?.id || null,
                    nacionalidad: this._getNacionalidadInicial(pasajeroExistente),
                    nombre: pasajeroExistente?.nombre || null,
                    numero_documento: pasajeroExistente?.numero_documento || null,
                    parentesco: pasajeroExistente?.parentesco || null,
                    poblacion: pasajeroExistente?.poblacion || null,
                    primer_apellido: pasajeroExistente?.primer_apellido || null,
                    provincia: pasajeroExistente?.provincia || null,
                    reserva_id: pasajeroExistente?.reserva_id || null,
                    segundo_apellido: pasajeroExistente?.segundo_apellido || null,
                    sexo: pasajeroExistente?.sexo || null,
                    soporte_documento: pasajeroExistente?.soporte_documento || null,
                    telefono_fijo: pasajeroExistente?.telefono_fijo || null,
                    telefono_movil: pasajeroExistente?.telefono_movil || null,
                    tipo_documento: pasajeroExistente?.tipo_documento || tipoDocumentoPorDefecto,
                };
            });
        },

        isRequiredField(field) {
            return this.requiredPassengerFields.includes(field);
        },

        getRequiredPassengerFields(pasajero) {
            const campos = this.mostrarFormularioReducido
                ? ['nombre', 'primer_apellido', 'numero_documento', 'telefono_movil']
                : [...this.requiredPassengerFields];
            if (!this.mostrarFormularioReducido && this.isSpanish && this.isNacionalidadEspania(pasajero) && (pasajero?.tipo_documento || '').toUpperCase() === 'DNI') {
                campos.push('soporte_documento');
            }
            return campos;
        },

        isNacionalidadEspania(pasajero) {
            const raw = (pasajero?.nacionalidad || '').toString().trim().toLowerCase();
            if (!raw) return false;
            return raw === 'españa' || raw === 'espana' || raw === 'es';
        },

        _formatFechaNacimientoFromApi(valor) {
            if (!valor) return null;
            const texto = String(valor).trim();
            const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (match) {
                const [, yyyy, mm, dd] = match;
                return `${dd}/${mm}/${yyyy}`;
            }
            return texto;
        },

        _getNacionalidadInicial(pasajeroExistente) {
            const existente = pasajeroExistente?.nacionalidad;
            if (existente) {
                const valor = String(existente).trim();
                const paisPorCodigo = this.codigosPais.find(p => p.code === valor.toUpperCase());
                if (paisPorCodigo) return paisPorCodigo.name;
                return valor;
            }
            if (this.isSpanish) {
                const espana = this.codigosPais.find(p => p.code === 'ES');
                return espana ? espana.name : 'España';
            }
            if ((this.language || '').toLowerCase() === 'de') {
                const alemania = this.codigosPais.find(p => p.code === 'DE');
                return alemania ? alemania.name : 'Alemania';
            }
            return null;
        },

        isMissingValue(value) {
            if (value === null || value === undefined) return true;
            if (typeof value === 'string') return value.trim() === '';
            return false;
        },

        isRequiredFieldMissing(pasajero, field) {
            const camposObligatorios = this.getRequiredPassengerFields(pasajero);
            if (!camposObligatorios.includes(field)) return false;
            return this.isMissingValue(pasajero?.[field]);
        },

        formulariosValidados() {
            return this.pasajerosMostrados.every(({ pasajero }) => {
                const camposObligatorios = this.getRequiredPassengerFields(pasajero);
                const camposCompletos = camposObligatorios.every(campo => {
                    const valor = pasajero[campo];
                    return valor !== null &&
                        valor !== undefined &&
                        (typeof valor === 'string' ? valor.trim() !== '' : true);
                });

                const emailValido = this._emailValido(pasajero.email);

                return camposCompletos && emailValido;
            });
        },


        _emailValido(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        getTituloCamino(camino) {
            if (this.language.toLowerCase() === 'es') {
                return camino.titulo;
            } else if (this.language.toLowerCase() === 'en') {
                return camino.titulo_EN;
            } else if (this.language.toLowerCase() === 'de') {
                return camino.titulo_DE;
            }
            return camino.titulo;
        },

        async _guardarDatosPasajeros() {
            if (!this.formulariosValidados()) {
                return;
            }
            const pasajerosConvertidos = this.pasajeros
                .map(pasajero => ({
                    ...pasajero,
                    fecha_nacimiento: this.convertirFechaAISO(pasajero.fecha_nacimiento)
                }));
            const response = await this.guardarDatosPasajeros([this.modelReserva, pasajerosConvertidos]);
            if (response) {
                this.pasajerosGuardados = true;
            }
        },

        convertirFechaAISO(fecha) {
            if (!fecha) return null;
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = fecha.match(regex);
            if (!match) {
                console.warn('Formato de fecha inválido:', fecha);
                return null;
            }
            const [, dia, mes, año] = match;
            return `${año}-${mes}-${dia}`;
        },

        formatearFecha(fecha) {
            let valor = fecha.replaceAll(/[^\d/]/g, '');
            if (valor.length >= 2 && valor.charAt(2) !== '/') {
                valor = valor.substring(0, 2) + '/' + valor.substring(2);
            }
            if (valor.length >= 5 && valor.charAt(5) !== '/') {
                valor = valor.substring(0, 5) + '/' + valor.substring(5);
            }

            if (valor.length > 10) {
                valor = valor.substring(0, 10);
            }

            this.$set(this.pasajeros[this.pasajeros.indexOf(this.pasajeros.find(p => p.fecha_nacimiento === fecha))], 'fecha_nacimiento', valor);
        },

        validarFormatoFecha(fecha) {
            if (!fecha) return true;

            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = fecha.match(regex);

            if (!match) {
                return 'Formato debe ser dd/mm/yyyy';
            }

            const dia = Number.parseInt(match[1]);
            const mes = Number.parseInt(match[2]);
            const año = Number.parseInt(match[3]);

            if (dia < 1 || dia > 31) {
                return 'Día debe estar entre 1 y 31';
            }
            if (mes < 1 || mes > 12) {
                return 'Mes debe estar entre 1 y 12';
            }
            if (año < 1900 || año > new Date().getFullYear()) {
                return `Año debe estar entre 1900 y ${new Date().getFullYear()}`;
            }

            const fechaObj = new Date(año, mes - 1, dia);
            if (fechaObj.getDate() !== dia || fechaObj.getMonth() !== mes - 1 || fechaObj.getFullYear() !== año) {
                return 'Fecha no válida';
            }

            return true;
        },

    },
}

</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.required-field ::v-deep .v-label {
    color: #d32f2f !important;
}

.required-field ::v-deep .v-label::after {
    content: ' *';
    color: #d32f2f;
}

.flying-document-container {
    position: relative;
    height: 150px;
    width: 100%;
    overflow: hidden;
}

.flying-document {
    position: relative;
    animation: fly 2s infinite ease-in-out;
}

.wind-line {
    position: absolute;
    height: 2px;
    background: #FF9C00;
    opacity: 0.6;
    animation: wind 2s infinite ease-in-out;
}

.wind-line-1 {
    width: 50px;
    top: 40%;
    left: 30%;
}

.wind-line-2 {
    width: 30px;
    top: 50%;
    left: 45%;
    animation-delay: 0.2s;
}

.wind-line-3 {
    width: 40px;
    top: 60%;
    left: 35%;
    animation-delay: 0.4s;
}


@keyframes fly {
    0% {
        transform: translateX(-100%) translateY(20px) rotate(0deg);
    }

    50% {
        transform: translateX(0) translateY(0px) rotate(5deg);
    }

    100% {
        transform: translateX(100%) translateY(20px) rotate(0deg);
    }
}

@keyframes wind {
    0% {
        transform: translateX(-100%) scaleX(0.5);
        opacity: 0;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        transform: translateX(100%) scaleX(1);
        opacity: 0;
    }
}

.pulse-text {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}
</style>
